// extracted by mini-css-extract-plugin
module.exports = {"EmailContainer":"EmailFeature-module--EmailContainer--3wpOY","EmailLinkWrapper":"EmailFeature-module--EmailLinkWrapper--2jXjb","EmailLink":"EmailFeature-module--EmailLink--2-M-T"};